import React, { useMemo, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Row, Col } from "react-bootstrap";
import DataTable from "../components/datatable/DataTable";
import { suppliersTableConfig, makeSuppliersAdapter } from "../tableConfigs/suppliers";
import SupplierDetailPanel from "../components/SupplierDetailPanel";
import SupplierDupCandidates from "../components/SupplierDupCandidates";

export default function Suppliers() {
   const [selected, setSelected] = useState(null);
   const [refreshTick, setRefreshTick] = useState(0);
   const [totalRows, setTotalRows] = useState(null);
   const adapter = useMemo(() => makeSuppliersAdapter(), []);

   return (
      <>
         <Header />
         <div className="main main-app p-3 p-lg-4 p-xxl-5 suppliers-page">
            <Row className="g-3 g-lg-4 align-items-start">
               <Col>
                  <div className="d-flex align-items-center gap-2">
                     <h2 className="main-title fs-4 mb-1">Suppliers</h2>
                     {totalRows != null && (
                        <span className="payee-count-chip">
                           {Number(totalRows).toLocaleString()} suppliers
                        </span>
                     )}
                  </div>
                  <p className="page-subtitle">
                     Who your statements get paid to. Suppliers come from the ERP sync; every name
                     a supplier goes by rolls up to one payee here.
                  </p>
               </Col>
            </Row>
            <SupplierDupCandidates
               onReview={(row) => setSelected(row)}
               refreshTick={refreshTick}
               onChanged={() => setRefreshTick((t) => t + 1)}
            />
            <div className="data-table-card">
               <DataTable
                  key={`suppliers-${refreshTick}`}
                  config={suppliersTableConfig}
                  adapter={adapter}
                  onRowClick={(row) => setSelected(row)}
                  onMeta={({ totalRows: t }) => setTotalRows(t)}
               />
            </div>
            {selected && (
               <SupplierDetailPanel
                  supplier={selected}
                  onClose={() => setSelected(null)}
                  onChanged={() => setRefreshTick((t) => t + 1)}
               />
            )}
            <Footer />
         </div>
      </>
   );
}
